module.exports = __webpack_public_path__ + "static/media/ic_excel.1ed1238e.png";